<template>
  <div class="nav-footer">
    <div class="footer-background">
      <div class="container">
        <!-- 主要内容区域 -->
        <div class="footer-main">
          <!-- 左侧公司信息 -->
          <div class="company-info">
            <div class="company-logo">
              <h3>北京邑维智能科技有限公司</h3>
              <p class="company-tagline">专业互联网资讯服务</p>
            </div>
            <div class="contact-info">
              <div class="contact-item">
                <span class="contact-icon">📍</span>
                <span class="contact-text">公司地址：北京市大兴区长子营镇民安路6号1层1091</span>
              </div>
              <!-- <div class="contact-item">
                <span class="contact-icon">📞</span>
                <span class="contact-text">公司电话：010-65210616</span>
              </div> -->
              <div class="contact-item">
                <span class="contact-icon">📧</span>
                <span class="contact-text">公司邮箱：dawei304@163.com</span>
              </div>
            </div>
          </div>

          <!-- 右侧链接和备案信息 -->
          <div class="footer-links">
            <div class="link-group">
              <!-- <h4>快速链接</h4> -->
              <div class="link-list">
                <!-- <a href="/" class="footer-link">网站首页</a> -->
                <!-- <a href="/#/ac1" class="footer-link">行业资讯</a> -->
                <!-- <a href="/#/ac2" class="footer-link">纠纷处理</a> -->
                <!-- <a href="/#/xy" class="footer-link">用户协议</a> -->
              </div>
            </div>
            
            <div class="legal-info">
              <div class="record-info">
                <a href="https://beian.miit.gov.cn/#/Integrated/index" class="record-link">
                  <span class="record-icon">🔒</span>
                  备案号：京ICP备2025103279号-11
                </a>
              </div>
              <div class="copyright">
                Copyright © 20256 北京邑维智能科技有限公司 版权所有
              </div>
            </div>
          </div>
        </div>

        <!-- 底部装饰线 -->
        <div class="footer-divider"></div>

        <!-- 底部标语 -->
        <div class="footer-slogan">
          <p>探索世界之美，分享资讯之乐</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
// 使用方案2的颜色变量
$primary-color: #d4b896;
$primary-dark: #bfa07d;
$primary-light: #e9d4b8;
$accent-color: #5a8fb4;
$text-dark: #2c3e50;
$text-light: #7f8c8d;
$background: #f9f7f2;
$card-bg: #ffffff;

.nav-footer {
  width: 100%;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: #ffffff;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  // margin-top: 80px;

  .footer-background {
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(5px);
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 50px 20px 30px;
  }

  .footer-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;

    // 左侧公司信息
    .company-info {
      flex: 1;
      padding-right: 40px;

      .company-logo {
        margin-bottom: 25px;

        h3 {
          font-size: 24px;
          font-weight: 700;
          color: $primary-color;
          margin-bottom: 8px;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        .company-tagline {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          font-style: italic;
        }
      }

      .contact-info {
        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          font-size: 14px;

          .contact-icon {
            margin-right: 10px;
            font-size: 16px;
            opacity: 0.8;
          }

          .contact-text {
            color: rgba(255, 255, 255, 0.9);
          }
        }
      }
    }

    // 右侧链接和备案信息
    .footer-links {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .link-group {
        margin-bottom: 25px;
        text-align: right;

        h4 {
          font-size: 18px;
          font-weight: 600;
          color: $primary-color;
          margin-bottom: 15px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .link-list {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .footer-link {
            color: rgba(255, 255, 255, 0.8);
            text-decoration: none;
            font-size: 14px;
            transition: all 0.3s ease;
            padding: 5px 0;

            &:hover {
              color: $primary-color;
              transform: translateX(-5px);
            }
          }
        }
      }

      .legal-info {
        text-align: right;

        .record-info {
          margin-bottom: 10px;

          .record-link {
            display: inline-flex;
            align-items: center;
            color: rgba(255, 255, 255, 0.7);
            text-decoration: none;
            font-size: 13px;
            transition: color 0.3s ease;

            &:hover {
              color: $primary-color;
            }

            .record-icon {
              margin-right: 6px;
              font-size: 12px;
            }
          }
        }

        .copyright {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }

  // 底部装饰线
  .footer-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, $primary-color, transparent);
    margin: 20px 0;
    opacity: 0.3;
  }

  // 底部标语
  .footer-slogan {
    text-align: center;
    padding-top: 15px;

    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      font-style: italic;
      letter-spacing: 1px;
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .nav-footer {
    .footer-main {
      flex-direction: column;
      
      .company-info {
        padding-right: 0;
        margin-bottom: 30px;
      }
      
      .footer-links {
        align-items: flex-start;
        width: 100%;
        
        .link-group {
          text-align: left;
        }
        
        .legal-info {
          text-align: left;
        }
      }
    }
  }
}
</style>